<main class="password">
  <div class="password-section">
    <h3 class="password-section-title">User Identity</h3>

    <label class="form-input-wrapper">
      <span class="form-input-label">Username:</span>
      <input *ngIf="!isLoading; else identitySkeleton" [value]="login" readonly class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">Reserved e-mail:</span>
      <input *ngIf="!isLoading; else identitySkeleton" [value]="email" readonly class="form-input_md" />
    </label>
  </div>

  <ng-template #identitySkeleton>
    <span class="skeleton form-input-skeleton_md form-input-skeleton"></span>
  </ng-template>

  <div class="password-section">
    <h3 class="password-section-title">Password Management</h3>

    <label class="form-input-wrapper">
      <span class="form-input-label">Old Password:</span>

      <input
        type="password"
        name="oldPassword"
        [(ngModel)]="oldPassword"
        required
        [disabled]="isPasswordLocked"
        class="form-input_md"
        [class.input_disabled]="isPasswordLocked"
      />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">New Password:</span>

      <input
        type="password"
        name="newPassword"
        [(ngModel)]="newPassword"
        required
        pattern="^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\W).*$"
        minlength="8"
        [disabled]="isPasswordLocked"
        class="form-input_md"
        [class.input_disabled]="isPasswordLocked"
      />
    </label>

    <p class="password-hint">
      password must be at least 8 characters and contain 1 uppercase, 1 lowercase and 1 special character
    </p>

    <label class="form-input-wrapper">
      <span class="form-input-label">Confirm Password:</span>

      <input
        type="password"
        name="repeatPassword"
        [(ngModel)]="repeatPassword"
        required
        [disabled]="isPasswordLocked"
        [class.input_disabled]="isPasswordLocked"
        class="form-input_md"
        [class.form-input_invalid]="!isRepeatPasswordValid"
      />
    </label>

    <div class="password-buttons-wrapper">
      <button [disabled]="areInputsInvalid" class="btn_primary btn_sm" (click)="updatePassword()">
        Change password
      </button>

      <button class="icon-btn" [class.btn_inactive]="!isPasswordLocked" (click)="togglePasswordLock()">
        <img src="assets/img/icons/lock.svg" alt="Lock/Unlock password for change" />
      </button>

      <span class="password-form__button-text">(unlock password change)</span>
    </div>
  </div>
</main>

<app-success-modal title="Successfully" text="Password changed successfully"></app-success-modal>
